import BaseModule from "~/vuex/modules/base-module";
//import Roles from "./roles";

let Users = {...BaseModule};

Users.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/users';
    state.endpoints['validate-email'] = '/api/users/validate-email';


    return state;
};

Users.mutations.reset = function(state) {
    state.all = [];
    state.invalidEmails = [];
};

Users.mutations.addInvalidEmail = function(state, email) {
    state.invalidEmails.push(email);
};

Users.getters.invalidEmails = function(state) {
    return state.invalidEmails;
};

Users.actions.markCustomerEmailVerified = async function ({state},id) {
    let response = await this.axios.post('/api/customer/verify-email',id);
    if (response.status == 200) {
        return true;
    }
    return false;
};

Users.actions.ResetCustomerPassword = async function ({state},id) {
    let response = await this.axios.post('/api/customer/generate-password',id);

    if (response.status == 200 && response.data.success) {
        return response.data;
    }
    return false;
};

Users.actions.emailIsValid = async function({
                                                commit,
                                                state,
                                                getters,
                                                rootGetters
                                            }, email) {

    if (email == rootGetters['auth/getUserEmail']) {
        console.log('Weird');
        return true;
    }

    let invalidEmails = getters['invalidEmails'];


    if (typeof invalidEmails === 'undefined') {
        invalidEmails = [];
        state.invalidEmails = [];
    }

    if (invalidEmails.includes(email)) {
        return false;
    }

    let response = await this.axios.post(state.endpoints['validate-email'], {email: email});


    if (response.data == 'available') {
        return true;
    }

    commit('addInvalidEmail', email);

    return false;
};

Users.getters.byRole = function(state, getters) {
    return function(roleId) {
        return getters['allValues'].filter(elem => {
            return elem.hasOwnProperty('pivot') && elem.pivot.hasOwnProperty('role_id') && elem.pivot.role_id === roleId
        })
    }
};

Users.getters.byTeam = function(state, getters) {
    return function(teamId) {
        return getters['allValues'].filter(elem => {
            return elem.hasOwnProperty('pivot') && elem.pivot.hasOwnProperty('team_id') && elem.pivot.team_id === teamId
        })
    }
};

Users.actions.searchUser = async function ({ commit, dispatch, getters, state, rootGetters }, data = {}) {
    if (!data.searchInput) {
        return false;
    }
    state.endpoints['search'] = '/api/users/search';

    return dispatch('search', {
        term: data.searchInput,
        includes: [],
        page: data.page,
        perPage: data.per_page,
    });
};

export default Users;
